// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderFacility,
    ProviderFacilitySortType,
    SupportCreateFacilityPayload,
    SupportFacility,
    SupportFacilitySortType,
    SupportReplaceFacilityPayload,
    SupportUpdateFacilityPayload,
    SupportCreateFacilityPayloadToJSON,
    SupportReplaceFacilityPayloadToJSON,
    SupportUpdateFacilityPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderFacilityFromJSON,
    SupportFacilityFromJSON,
} from '../models';

export interface CreateSupportFacilityRequest {
    supportCreateFacilityPayload: SupportCreateFacilityPayload;
}

export interface DisableSupportFacilityRequest {
    id: string;
}

export interface GetProviderFacilityRequest {
    id: string;
}

export interface GetSupportFacilityRequest {
    id: string;
}

export interface ListProviderFacilitiesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderFacilitiesOrderEnum>;
    filterCreated?: Array<string>;
    filterName?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterNpi?: Array<string>;
    filterEin?: Array<string>;
    filterSsn?: Array<string>;
    filterOther?: Array<string>;
    filterPlaceOfServiceType?: Array<string>;
    sort?: Array<ProviderFacilitySortType>;
}

export interface ListSupportFacilitiesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportFacilitiesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterActive?: string;
    filterName?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterNpi?: Array<string>;
    filterEin?: Array<string>;
    filterSsn?: Array<string>;
    filterOther?: Array<string>;
    filterPlaceOfServiceType?: Array<string>;
    sort?: Array<SupportFacilitySortType>;
}

export interface ReplaceSupportFacilityRequest {
    supportReplaceFacilityPayload: SupportReplaceFacilityPayload;
}

export interface UpdateSupportFacilityRequest {
    id: string;
    supportUpdateFacilityPayload: SupportUpdateFacilityPayload;
}

/**
 * no description
 */
export class FacilityApi extends runtime.BaseAPI {

    /**
     * Creates a facility
     * Create a facility
     */
    async createSupportFacilityRaw(requestParameters: CreateSupportFacilityRequest): Promise<runtime.ApiResponse<SupportFacility>> {
        if (requestParameters['supportCreateFacilityPayload'] === null || requestParameters['supportCreateFacilityPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateFacilityPayload','Required parameter requestParameters.supportCreateFacilityPayload was null or undefined when calling createSupportFacility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:facility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/facility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateFacilityPayloadToJSON(requestParameters['supportCreateFacilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportFacilityFromJSON(jsonValue));
    }

    /**
     * Creates a facility
     * Create a facility
     */
    async createSupportFacility(requestParameters: CreateSupportFacilityRequest): Promise<SupportFacility> {
        const response = await this.createSupportFacilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a facility
     * Disable a facility
     */
    async disableSupportFacilityRaw(requestParameters: DisableSupportFacilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportFacility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:facility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/facility/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a facility
     * Disable a facility
     */
    async disableSupportFacility(requestParameters: DisableSupportFacilityRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportFacilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a facility
     * Get a facility
     */
    async getProviderFacilityRaw(requestParameters: GetProviderFacilityRequest): Promise<runtime.ApiResponse<ProviderFacility>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderFacility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:facility"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/facility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderFacilityFromJSON(jsonValue));
    }

    /**
     * Gets a facility
     * Get a facility
     */
    async getProviderFacility(requestParameters: GetProviderFacilityRequest): Promise<ProviderFacility> {
        const response = await this.getProviderFacilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a facility
     * Get a facility
     */
    async getSupportFacilityRaw(requestParameters: GetSupportFacilityRequest): Promise<runtime.ApiResponse<SupportFacility>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportFacility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:facility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/facility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportFacilityFromJSON(jsonValue));
    }

    /**
     * Gets a facility
     * Get a facility
     */
    async getSupportFacility(requestParameters: GetSupportFacilityRequest): Promise<SupportFacility> {
        const response = await this.getSupportFacilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of facilities
     * Get a list of facilities
     */
    async listProviderFacilitiesRaw(requestParameters: ListProviderFacilitiesRequest): Promise<runtime.ApiResponse<Array<ProviderFacility>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterEin) {
            queryParameters['filterEin'] = requestParameters.filterEin;
        }

        if (requestParameters.filterSsn) {
            queryParameters['filterSsn'] = requestParameters.filterSsn;
        }

        if (requestParameters.filterOther) {
            queryParameters['filterOther'] = requestParameters.filterOther;
        }

        if (requestParameters.filterPlaceOfServiceType) {
            queryParameters['filterPlaceOfServiceType'] = requestParameters.filterPlaceOfServiceType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:facility"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/facility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderFacilityFromJSON));
    }

    /**
     * Gets a list of facilities
     * Get a list of facilities
     */
    async listProviderFacilities(requestParameters: ListProviderFacilitiesRequest): Promise<Array<ProviderFacility>> {
        const response = await this.listProviderFacilitiesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of facilities
     * Get a list of facilities
     */
    async listSupportFacilitiesRaw(requestParameters: ListSupportFacilitiesRequest): Promise<runtime.ApiResponse<Array<SupportFacility>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterEin) {
            queryParameters['filterEin'] = requestParameters.filterEin;
        }

        if (requestParameters.filterSsn) {
            queryParameters['filterSsn'] = requestParameters.filterSsn;
        }

        if (requestParameters.filterOther) {
            queryParameters['filterOther'] = requestParameters.filterOther;
        }

        if (requestParameters.filterPlaceOfServiceType) {
            queryParameters['filterPlaceOfServiceType'] = requestParameters.filterPlaceOfServiceType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:facility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/facility`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportFacilityFromJSON));
    }

    /**
     * Gets a list of facilities
     * Get a list of facilities
     */
    async listSupportFacilities(requestParameters: ListSupportFacilitiesRequest): Promise<Array<SupportFacility>> {
        const response = await this.listSupportFacilitiesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a facility
     * Replace a facility
     */
    async replaceSupportFacilityRaw(requestParameters: ReplaceSupportFacilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceFacilityPayload'] === null || requestParameters['supportReplaceFacilityPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceFacilityPayload','Required parameter requestParameters.supportReplaceFacilityPayload was null or undefined when calling replaceSupportFacility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:facility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/facility/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceFacilityPayloadToJSON(requestParameters['supportReplaceFacilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a facility
     * Replace a facility
     */
    async replaceSupportFacility(requestParameters: ReplaceSupportFacilityRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportFacilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a facility
     * Update a facility
     */
    async updateSupportFacilityRaw(requestParameters: UpdateSupportFacilityRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportFacility.');
        }

        if (requestParameters['supportUpdateFacilityPayload'] === null || requestParameters['supportUpdateFacilityPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateFacilityPayload','Required parameter requestParameters.supportUpdateFacilityPayload was null or undefined when calling updateSupportFacility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:facility", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/facility/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateFacilityPayloadToJSON(requestParameters['supportUpdateFacilityPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a facility
     * Update a facility
     */
    async updateSupportFacility(requestParameters: UpdateSupportFacilityRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportFacilityRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderFacilitiesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportFacilitiesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
